import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { IOuter } from '../../EmptyState.types';
import styles from './BoardSubtitle.scss';

export const BoardSubtitle: FC<IOuter> = () => (
  <span className={styles.boardSubtitle}>
    <FormattedMessage id="empty-state.board.subtitle-new" />
  </span>
);
